import { ref, computed, watch, onMounted } from 'vue'
import { themes, themeModes, getThemeConfig, getSystemTheme } from '../theme'

// 当前主题模式（默认暗色主题）
const currentThemeMode = ref('dark')

// 创建主题 composable
export function useTheme() {
  // 当前主题配置
  const currentTheme = computed(() => {
    return getThemeConfig(currentThemeMode.value)
  })

  // 是否为暗色模式
  const isDark = computed(() => {
    return currentThemeMode.value === themeModes.DARK
  })

  // 主题颜色
  const colors = computed(() => {
    return currentTheme.value.colors
  })

  // 切换主题
  const toggleTheme = () => {
    const nextMode = currentThemeMode.value === themeModes.LIGHT 
      ? themeModes.DARK 
      : themeModes.LIGHT
    setTheme(nextMode)
  }

  // 设置主题
  const setTheme = (mode) => {
    if (themes[mode]) {
      currentThemeMode.value = mode
      localStorage.setItem('theme', mode)
    }
  }

  // 跟随系统主题
  const setSystemTheme = () => {
    const systemTheme = getSystemTheme()
    setTheme(systemTheme)
  }

  // 监听主题变化
  watch(currentThemeMode, (newMode) => {
    // 更新 HTML 元素的 class
    document.documentElement.classList.remove('light', 'dark')
    document.documentElement.classList.add(newMode)

    // 更新 body 背景色
    document.body.className = ''
    if (newMode === themeModes.DARK) {
      document.body.classList.add('bg-gray-900')
    } else {
      document.body.classList.add('bg-gray-50')
    }
  }, { immediate: true })

  // 初始化主题
  onMounted(() => {
    // 优先从 localStorage 读取用户切换过的主题
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme && themes[savedTheme]) {
      currentThemeMode.value = savedTheme
    }
    // 无记录时默认使用暗色主题（currentThemeMode 已为 'dark'）
  })

  return {
    // 主题状态
    isDark,
    currentTheme,
    currentThemeMode,
    colors,
    
    // 主题操作
    toggleTheme,
    setTheme,
    setSystemTheme,
    
    // 常量
    themes,
    themeModes
  }
}

// 获取颜色类的便捷函数
export function useThemeColor(colorKey) {
  const { colors } = useTheme()
  return computed(() => colors.value[colorKey] || '')
}
